import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";

import { UserService, VoucherService } from "@services";
import {
  getUser,
  getUserError,
  getUserSuccess,
  getUserTokens,
  getUserTokensError,
  getUserTokensSuccess,
} from "./user.actions";

@Injectable()
export class UserEffects {
  public readonly getUser$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getUser),
      mergeMap(() =>
        this._userService.getCurrentUser().pipe(
          map((user) => getUserSuccess({ user })),
          catchError((error) => of(getUserError({ error }))),
        ),
      ),
    ),
  );

  public readonly getUserTokens$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getUserTokens),
      mergeMap(() =>
        this._voucherService.getUserAvailableTokens().pipe(
          map((response) => getUserTokensSuccess({ tokens: response.amount })),
          catchError((error) => of(getUserTokensError({ error }))),
        ),
      ),
    ),
  );

  constructor(
    private _actions$: Actions,
    private _userService: UserService,
    private _voucherService: VoucherService,
  ) {}
}
